var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.74 38.57a19 19 0 110-38 19 19 0 010 38zm1.9-8.98v-3.84H17.8v3.84zm1.02-8.83a6.68 6.68 0 003.77-6.04A6.8 6.8 0 0019.72 8 6.7 6.7 0 0013 14.72h3.84a2.88 2.88 0 012.88-2.88 2.96 2.96 0 012.88 2.88c0 1.1-.63 2.1-1.62 2.59a5.88 5.88 0 00-3.18 5.3v.26h3.84v-.25a2.03 2.03 0 011.02-1.86z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--question-56d7088407e0642d6995d0f1545baf3f.svg";
export { SvgIconCircleQuestion as Component };